export default "__VITE_ASSET__JBa81jzN__"